import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import { Navigation } from "react-router";
import PaymentMethodUpdater from "../partials/payment-method-updater.jsx";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../stores/PersonStore";
import PersonActions from "../../actions/PersonActions";

export default statics(
  {
    willTransitionTo({ params }, replace, callback) {
      PersonActions.resetPaymentInfoUpdate();
      callback();
    }
  },

  @connectToStores
  class EditPaymentMethod extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        hasNotGoneBack: true,
        isComplete: false
      };

      this.cancel = this.cancel.bind(this);
      this.goBack = this.goBack.bind(this)
    }

    static getStores() {
      return [PersonStore];
    }

    static getPropsFromStores() {
      return PersonStore.getState();
    }

    static get contextTypes() {
      return {
        tenant: React.PropTypes.object,
        router: React.PropTypes.object.isRequired
      };
    }

    goBack() {
      const location = this.context.router.location || this.context.router.getCurrentLocation()
      if (
        !this.context.tenant.checkout_v2_optout &&
        location.query.checkout !== "true"
      ) {
        this.context.router.push("/account");
      } else {
        this.context.router.goBack();
      }
    }

    cancel() {
      // Eventive Everywhere 
      if (this.props.onCancel) {
        this.props.onCancel();
        return;
      }

      if (!this.props.paymentInfoUpdateInProgress) {
        this.goBack();
      }
    }

    componentWillReceiveProps(props) {
      // Assume success
      if (this.state.hasNotGoneBack && props.paymentInfoUpdateSuccess) {
        
        // Eventive Everywhere 
        if (this.props.onComplete) {
          this.props.onComplete();
          return;
        }

        this.goBack();
        this.setState({
          hasNotGoneBack: false
        });
      }
    }

    render() {
      return (
        <BaseOverlay
          onRequestClose={this.cancel}
          className={this.props.className}
          zIndex={3000}
        >
          <div style={{ textAlign: "center", fontSize: "11pt" }}>
            <h3 style={{ marginBottom: "0.5em" }}>Payment information</h3>
            <div style={{ marginBottom: "0.5em" }}>
              To update your payment information, just enter your new details
              below.
            </div>
            <PaymentMethodUpdater onCancel={this.cancel} onToken={this.complete} />
          </div>
        </BaseOverlay>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/edit-payment-method.jsx